// FAQ content for CareFirst Home Health (SEO + FAQ schema)

export const FAQS = [
  {
    q: "What is home health care?",
    a: "Home health care is professional medical and supportive care delivered in a patient's home. It can include skilled nursing, therapy, personal care, and help with daily activities, allowing people to recover and live safely without leaving home.",
  },
  {
    q: "What is the difference between home health and non-medical home care?",
    a: "Home health typically includes clinical services such as skilled nursing provided by licensed professionals, often under a physician's orders. Non-medical home care focuses on personal care, companionship, and help with daily living. CareFirst provides both skilled and non-skilled services.",
  },
  {
    q: "Does Medicare cover home health?",
    a: "Medicare may cover eligible home health services when ordered by a physician and provided by a certified agency. Coverage depends on your specific plan and medical need. Our team can help you understand your options.",
  },
  {
    q: "Does Medicaid cover home care?",
    a: "Ohio Medicaid and waiver programs such as PASSPORT and DODD may cover in-home care for those who qualify. CareFirst works with Medicaid managed-care plans and can help verify eligibility.",
  },
  {
    q: "How do I start services?",
    a: "Getting started is easy. Call us, request care online, or ask your physician or hospital to send a referral. We complete an assessment, confirm coverage, and build a personalized care plan.",
  },
  {
    q: "Can a hospital or physician send a referral?",
    a: "Yes. We welcome referrals from physicians, hospitals, discharge planners, social workers, and case managers. Referrals can be sent by phone, fax, or our online referral form.",
  },
  {
    q: "How quickly can services start?",
    a: "In many cases we can begin services promptly after a referral and assessment. Timing depends on the level of care needed and insurance verification. We prioritize timely responses for hospital discharges.",
  },
  {
    q: "What areas do you serve?",
    a: "We serve Columbus and surrounding Central Ohio communities including Westerville, Dublin, Worthington, Gahanna, Reynoldsburg, Grove City, Hilliard, Pickerington, New Albany, Whitehall, Upper Arlington, Bexley, and Canal Winchester.",
  },
  {
    q: "Do you provide skilled nursing?",
    a: "Yes. Our licensed RNs and LPNs provide skilled nursing services including wound care, medication administration, disease management, and post-hospital recovery support.",
  },
  {
    q: "Do you provide home health aides?",
    a: "Yes. Our certified home health aides assist with bathing, dressing, grooming, mobility, and other activities of daily living.",
  },
  {
    q: "Can family members request services?",
    a: "Absolutely. Family members can contact us directly to request care or arrange an assessment for a loved one.",
  },
  {
    q: "What documents are needed for a referral?",
    a: "Helpful documents include patient contact information, insurance or program details, a physician order (when applicable), and relevant medical history or discharge paperwork. Our team will guide you through what's needed.",
  },
];
